import m from 'mithril';
import {trans} from "../helpers";

import Steps from './steps.js';

let challenge_state = require('../new_challenge_creator/challengeState.js');


window.state = challenge_state;

let copied_url = false;

class ShareBox {
    view() {
        let box_class = '.article-share.article-share--boxed';

        if (challenge_state.exercise_editor_state.exercise.public == 0 && challenge_state.exercise_editor_state.exercise.unlisted == 0) {
            box_class += '.article-share--one-line';
        }

        return m(box_class, [
            (challenge_state.exercise_editor_state.exercise.public == 1 || challenge_state.exercise_editor_state.exercise.unlisted == 1) &&
            m('p', trans('exercises.congratulations_msg')),
            m('.article-share__copy-link', [
                m('.ijf-form', [
                    m('.line', [
                        m('.line-element', [
                            m('input', {
                                id: 'exerciseUrl',
                                type: 'text',
                                value: SPORTNETXPAGE.BASEURL + "/exercise/view/" + challenge_state.exercise_editor_state.exercise.slug,
                                readonly: true,
                                onclick: e => {
                                    let url_text = document.getElementById("exerciseUrl");

                                    url_text.select();
                                    url_text.setSelectionRange(0, 99999); // For mobile devices
                                }
                            })
                        ]),
                        m('.line-element', [
                            m('.btn.btn--main.btn--transition' + (copied_url ? '.btn--green' : '.btn--main'), {
                                onclick: e => {
                                    let url_text = document.getElementById("exerciseUrl");

                                    url_text.select();
                                    url_text.setSelectionRange(0, 99999); // For mobile devices

                                    document.execCommand("copy");

                                    url_text.setSelectionRange(0, 0);
                                    copied_url = true;
                                }
                            }, copied_url ? trans('common.copied')+'!' : trans('common.copy'))
                        ])
                    ])
                ])
            ]),
            (challenge_state.exercise_editor_state.exercise.public == 1 || challenge_state.exercise_editor_state.exercise.unlisted == 1) &&
            m('.article-share__icons', [
                m('a', { 
                    href: "https://www.facebook.com/sharer/sharer.php?u=" + SPORTNETXPAGE.BASEURL + "/exercise/view/" + challenge_state.exercise_editor_state.exercise.slug,
                    target: "_blank"
                }, [
                    m('div.article-share__icon.facebook--white'),
                    m('div.article-share__name', trans('common.share_facebook')),
                ]),
                m('a', { 
                    href: "https://twitter.com/home?status=" + SPORTNETXPAGE.BASEURL + "/exercise/view/" + challenge_state.exercise_editor_state.exercise.slug,
                    target: "_blank"
                }, [
                    m('div.article-share__icon.twitter--white'),
                    m('div.article-share__name', trans('common.share_twitter')),
                ]),
                m('a', { 
                    href: "mailto:friend@example.com?subject=Športni izziv&body= " + SPORTNETXPAGE.BASEURL + "/exercise/view/" + challenge_state.exercise_editor_state.exercise.slug,
                }, [
                    m('div.article-share__icon.email--white'),
                    m('div.article-share__name', trans('common.share_email')),
                ]),
                m('a', { 
                    href: "https://telegram.me/share/url?url=" + SPORTNETXPAGE.BASEURL + "/exercise/view/" + challenge_state.exercise_editor_state.exercise.slug,
                    target: "_blank"
                }, [
                    m('div.article-share__icon.telegram--white'),
                    m('div.article-share__name', trans('common.share_telegram')),
                ]),
            ])
        ]);
    }
}

class ExerciseCreated {
    exerciseUpdated() {
        return [
            m('h2.editor-title', trans('exercises.successfuly_updated')),

            m(ShareBox),

            m('br'),

            m('a.btn.btn--main', {
                href: '/myprofile/exercises',
            }, trans('challenge.back_to_profile')),
        ]
    }

    exerciseCreated() {
        return [
            m('h2.editor-title', trans('exercises.successfuly_created')),

            m(ShareBox),

            m('br'),

            m('a.btn.btn--main', {
                href: '/myprofile/exercises',
            }, trans('challenge.back_to_profile')),
        ]
    }

    view() {
        if (challenge_state.mode == 'update_exercise') {
            return this.exerciseUpdated();
        }
        
        return this.exerciseCreated();
    }
}

export default ExerciseCreated;